import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  StatusChipConfig,
  StatusChipConfigMap,
  StatusChipVariant,
} from '../status-chip/status-chip.component';

export interface ActionSelectOption {
  label: string;
  value: any;
  status?: string;
  state?: string;
  statusVariant?: StatusChipVariant | string;
  statusConfig?: StatusChipConfig;
  amount?: number;
  [key: string]: any;
}

@Component({
  selector: 'hospitality-bot-action-select, hospitality-bot-folio-select',
  templateUrl: './action-select.component.html',
  styleUrls: ['./action-select.component.scss'],
})
export class ActionSelectComponent {
  @Input() controlName: string = '';
  @Input() label: string = '';
  @Input() required: boolean = false;
  @Input() options: ActionSelectOption[] = [];
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() isAppendToBody: boolean = true;
  @Input() panelStyleClass: string = 'action-select-dropdown-panel';
  @Input() placeholder: string = 'Select option';
  @Input() statusChipConfig?: StatusChipConfigMap;

  // Header Action Button (e.g. "+ New", "+ Create", "+ Add")
  @Input() showHeader: boolean = true;
  @Input() showActionBtn: boolean = false;
  @Input() actionBtnText: string = 'New';
  @Input() actionBtnIcon: string = 'pi pi-plus';

  // Side Button (e.g. Preview eye, View, Edit, Info)
  @Input() showSideBtn: boolean = false;
  @Input() sideBtnIcon: string = 'pi pi-eye';
  @Input() sideBtnTooltip: string = 'Preview';
  @Input() sideBtnDisabled: boolean = false;

  // Empty State Notice
  @Input() showEmptyNotice: boolean = false;
  @Input() emptyNoticeText: string = 'No options available.';
  @Input() showEmptyActionBtn: boolean = true;
  @Input() emptyActionBtnText: string = 'Create New';
  @Input() emptyActionBtnIcon: string = 'pi pi-plus';

  // Hints & Warnings
  @Input() hint: string = '';
  @Input() showHintIcon: boolean = false;
  @Input() warningHint: string = '';

  // Options Display Flags
  @Input() showStatusChip: boolean = true;
  @Input() showAmount: boolean = true;

  // Outputs
  @Output() onActionClick = new EventEmitter<void>();
  @Output() onSideBtnClick = new EventEmitter<void>();
  @Output() itemSelection = new EventEmitter<any>();

  get selectProps() {
    return {
      placeholder: this.placeholder,
      isAppendToBody: this.isAppendToBody,
    };
  }
}
